import { makeAutoObservable } from 'mobx'
import { cloneDeep, flatten, zipWith, filter, find } from '@dt/fe-utils/dist/lodash'
import { toDecimal, pk } from '@dt/fe-utils'
import { convertModifierGroupsToDoModifierGroups, createFkey } from './center/cookware'
import { restaurantConfig, productMobx, cartMobx, productSaleMobx, discountMobx } from '..'
import feeMobx from './fee.mobx'

// 将口味cntMap转换成modifierGroups
const modifierGroupItemToCntMapTomodifierGroups = (modifierGroupItemToCntMap: any, productNo: string) => {
  const product = productMobx.noToViewProductMap[productNo]
  if (!product) {
    return []
  }
  const productComponents = product.modifierGroups
  const modifierGroups = cloneDeep(productComponents) as IDoModifierGroup[]
  modifierGroups.forEach((modifierGroup: IDoModifierGroup) => {
    // 处理默认选中逻辑
    let modifierGroupC: number = 0
    let modeFlag: 'single' | 'multiSingle' | 'multi' = modifierGroup.selectMax === 1 ? 'single' : 'multiSingle'
    modifierGroup.modifiers = modifierGroup.modifiers.map((item: IModifier) => {
      const filterDoItemC = modifierGroupItemToCntMap[`${modifierGroup.no}_${item.no}`] || 0
      modifierGroupC += filterDoItemC
      return { ...item, cnt: filterDoItemC }
    })
    modifierGroup.cnt = modifierGroupC
    if (modifierGroupC >= modifierGroup.selectMin && modifierGroupC <= modifierGroup.selectMax) {
      modifierGroup.isReady = true
    }
    if (modifierGroup.maxCnt > 1 && modeFlag === 'multiSingle') {
      modeFlag = 'multi'
    }
    modifierGroup.mode = modeFlag
  })
  return modifierGroups
}

// 将一个口味组的pk转成口味modifierGroups
const restoreModifierGroupsPkTomodifierGroups = (pk: string, productNo: string) => {
  const modifierGroupPks = pk ? pk.split(';') : []
  // 制作原先已选的map
  const modifierGroupItemToCntMap: any = {}
  modifierGroupPks.forEach((modifierGroupPk) => {
    const [modifiergroupNo, modifierPkStrs] = modifierGroupPk.split(':')
    const modifierPks = modifierPkStrs.split(';')
    modifierPks.forEach(modifierPk => {
      const [modifierId, cnt] = modifierPk.split('*')
      modifierGroupItemToCntMap[`${modifiergroupNo}_${modifierId}`] = cnt
    })
  })
  return modifierGroupItemToCntMapTomodifierGroups(modifierGroupItemToCntMap, productNo)
}

// 将一个fkey还原成一个操作餐品doProduct
const restorePkToDoProduct = (fkey: string, cnt: number = 1) => {
  const [productNo, scaleNo, modifierGroupsPk] = fkey.split('_')
  // const productId = parseInt(productNo)
  // const scaleNo = parseInt(strScaleNo)
  const modifierGroups = restoreModifierGroupsPkTomodifierGroups(modifierGroupsPk, productNo)
  const viewProduct = productMobx.noToViewProductMap[productNo]
  if (!viewProduct) {
    console.error('the product is not exist')
    return
  }
  // 处理金额因为openPrice是一个可变金额所有需要另一个参数price
  if (viewProduct.isOpenPrice) {
    console.error('the product is a open price product, it not support')
    return
  }
  const scales = cloneDeep(viewProduct.scales)
  const doProduct = {
    type: viewProduct.type,
    no: viewProduct.no,
    name: viewProduct.name,
    pic: viewProduct.pic,
    cnt,
    scaleNo, // 默认选中第一个可售的规格
    isTogo: 0, // 当前暂时默认是false
    scales,
    modifierGroups,
    startTimeOffset: 0, // 当前默认startTimeOffset 0
    pk: pk()
  } as IDoProduct
  return doProduct
}

const getDefaultProduct = () => {
  return {
    type: '',
    id: 0,
    no: '',
    name: '',
    pic: '',
    cnt: 1,
    scales: [],
    modifierGroups: [],
    scaleNo: null,
    startTimeOffset: 0,
    isTogo: 0 as 0 | 1,
    introe: '',
    isScaleModifierGroup: false,
    itemPlan: null,
    taxCategoryId: 0,
    isTaxFree: false,
    allergys: [],
    tags: [],
  }
}

const getDefaultProductExt = () => {
  return {}
}

/**
 * 操作餐品模块
 * 当一个餐品在放入购物车前的临时状态用此模块
 */
class DoProduct {
  constructor () {
    makeAutoObservable(this)
  }

  /** 餐品中基础数据，增加scales和modifierGroups作为变化中介质 */
  doProduct: IDoProduct = getDefaultProduct()

  /** 额外信息 */
  doProductExt: any = getDefaultProductExt()

  /** doProduct的计算结果，提供是否已经支持加入到购物车等判断结果 */
  get doProductResult () {
    let modifierPrice = 0
    let modifierActualPrice = 0
    this.doProduct.modifierGroups.forEach((modifierGroup: IDoModifierGroup) => {
      modifierGroup.modifiers.forEach(item => {
        modifierPrice += item.price * item.cnt
        modifierActualPrice += (item?.actualPrice || 0) * item.cnt
      })
    })
    let isReady = false
    let price = 0
    let actualPrice = 0
    if (this.doProduct.scaleNo) {
      if (this.doProduct.modifierGroups.every((doComponent: IDoModifierGroup) => doComponent.isReady)) {
        isReady = true
      }

      const doScale = this.doProduct.scales.find((scale) => scale.no === this.doProduct.scaleNo)
      if (doScale) {
        // openPrice
        if (doScale.price === null) {
          isReady = false
        }
        price = doScale.price || 0
        actualPrice = doScale.actualPrice || 0
      }
    }
    if (typeof (this.doProduct.openPriceX) !== 'undefined' && this.doProduct.openPriceX !== -1) {
      price = this.doProduct.openPriceX || 0
    }
    const totalPrice = price + modifierPrice
    const totalActualPrice = actualPrice + modifierActualPrice
    const taxPrice = feeMobx.calTaxPrice(this.doProduct.taxCategoryId, totalActualPrice)
    return {
      price, // 餐品价
      modifierPrice, // 加料价
      isReady,
      totalPrice, // 总价
      totalActualPrice, // 实际总价（按优惠价格计算）
      taxPrice
    }
  }

  /** 将一个餐品放入到可操作餐品中，之后可以在doProductMobx访问，具体会添加上可选择的属性 */
  pick ({
    product,
    productNo,
    cartItem,
    cartItemPk,
    scaleNo,
    groupNo,
    addPrice,
    isOrderSwapBuy,
    // 首次加菜
    initAdd,
    isCombo,
    salesCnt,
  }: {
    product?: IViewProduct;
    addPrice?: number;
    productNo?: string;
    cartItem?: IViewCartItem;
    cartItemPk?: string;
    scaleNo?: string;
    groupNo?: string;
    isOrderSwapBuy?: boolean;
    initAdd?: boolean;
    isCombo?: boolean;
    cnt?: number;
    salesCnt?: number; // 起售份数 从套餐来，需要覆盖单餐品数值
  }) {
    // 可能是一个餐品 也可能是一个购物车项
    const hasDiscount = (restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk') && product && isOrderSwapBuy // 已有营销价格
    if (productNo || product) {
      let viewProduct = product || (productNo ? productMobx.noToViewProductMap[productNo] : undefined)
      let viewScales: IScale[] = []
      if (viewProduct) {
        // 将试图餐品变成操作餐品
        let scale: IScale
        let defaultModifierGroups: IModifierGroup
        // 隐藏时价
        // 来自于已经选中规格的餐品
        if (scaleNo) {
          scale = viewProduct.scales.find((scale) => scale.no === scaleNo) || viewProduct.scales.find((scale) => scale.isDefault) || viewProduct.scales[0]
          if (!scale) {
            console.error('the select scale is soldout')
            return
          }
        } else {
          // 选择默认规格逻辑过滤
          viewScales = cloneDeep(viewProduct.scales)
          viewScales = viewScales?.filter((scale: any) => {
            // 不可单卖 套餐不过滤
            const isDisable = !isCombo && scale.status === 'disable'
            // 时价
            const isOpenPrice = restaurantConfig.hideOpenPriceProduct && scale.isOpenPrice
            return !isDisable && !isOpenPrice
          })
          // TODO: 规格组内默认选中默认规则
          if (viewScales.length > 1 && restaurantConfig.hideOpenPriceProduct) {
            const defaultScale = viewScales.find((scale) => scale.isDefault && scale.saleCnt !== 0 && !scale.disable && !scale.isOpenPrice)
            if (defaultScale) {
              scale = defaultScale
            } else {
              scale = (viewScales.find((scale) => scale.saleCnt !== 0 && !scale.disable && !scale.isOpenPrice) || viewScales[0])
            }
          } else if (viewScales.length > 1 && !restaurantConfig.hideOpenPriceProduct) {
            const defaultScale = viewScales.find((scale) => scale.isDefault && scale.saleCnt !== 0 && !scale.disable)
            if (defaultScale) {
              scale = defaultScale
            } else {
              scale = (viewScales.find((scale) => scale.saleCnt !== 0 && !scale.disable) || viewScales[0])
            }
          } else {
            scale = viewScales[0]
          }
        }
        const modifierGroups = convertModifierGroupsToDoModifierGroups(viewProduct?.no, scale?.modifierGroups || viewProduct.modifierGroups)
        defaultModifierGroups = modifierGroups[0]
        const scales = cloneDeep(viewScales).map((scale: IScale) => {
          // 处理金额因为openPrice是一个可变金额所有需要另一个参数price
          if (scale.isOpenPrice) {
            scale.price = undefined
          } else if (!hasDiscount) {
            // 对接营销价格
            if (scale.price) {
              if (discountMobx.itemDiscountMap && discountMobx.itemDiscountMap[viewProduct?.no + '_' + scale.no]) {
                scale.discountPrice = discountMobx.itemDiscountMap[viewProduct?.no + '_' + scale.no].off
                scale.actualPrice = toDecimal(scale.price - scale.discountPrice) as number
              } else {
                scale.discountPrice = 0
                scale.actualPrice = scale.price
              }
            }
          }
          return scale
        })
        const doProduct = {
          type: viewProduct.type,
          id: viewProduct.id,
          no: viewProduct.no,
          name: viewProduct.name,
          pic: viewProduct.pic,
          pics: viewProduct.pics,
          cnt: initAdd ? salesCnt || viewProduct.salesCnt : 1,
          addPrice,
          scaleNo: scale ? scale.no : null, // 默认选中第一个可售的规格
          modifierGroupsNo: defaultModifierGroups ? defaultModifierGroups.no : null, // 默认选中第一个可售规格
          scales,
          isTogo: cartMobx.cartResult.isTogo, // 来自购物车的默认togo状态
          isCanTogo: viewProduct.isCanTogo,
          isSingleSale: viewProduct.isSingleSale,
          startTimeOffset: 0,
          isOpenPrice: viewProduct.isOpenPrice,
          isScaleOpenPrice: viewProduct.isScaleOpenPrice,
          modifierGroups,
          salesCnt: salesCnt || viewProduct.salesCnt,
          allergys: viewProduct.allergys,
          tags: viewProduct.tags,
          intro: viewProduct.intro,
          maxSalesCnt: viewProduct.maxSalesCnt,
          saleCnt: viewProduct.saleCnt,
          saleTotalCnt: viewProduct.saleTotalCnt,
          statSaleCnt: viewProduct.statSaleCnt,
          scaleGroupName: viewProduct.scaleGroup.name,
          picBig: viewProduct.picBig,
          picWidth: viewProduct.picWidth,
          picHeight: viewProduct.picHeight,
          itemPlan: null,
          isScaleModifierGroup: viewProduct.scales.some(scale => !!scale.modifierGroups),
          taxCategoryId: viewProduct.taxCategoryId,
          isTaxFree: false,
          isOrderSwapBuy,
          showType: viewProduct.showType,
        } as IDoProduct
        if (groupNo) {
          doProduct.groupNo = groupNo
        }
        // 判断当前餐品在购物车里
        if (!isCombo && this.isInCart(doProduct)) {
          doProduct.cnt = 1
        }
        this.doProduct = doProduct
      }
    } else if (cartItemPk || cartItem) {
      let viewCartItem = cartItem || (cartItemPk ? cartMobx.pkToViewCartItemMap[cartItemPk] : undefined)
      if (viewCartItem?.productGroups) {
        console.error('Use doCombo pick the combo cart item')
        return
      }
      if (viewCartItem) {
        let viewProduct = productMobx.noToViewProductMap[viewCartItem.productNo]
        let viewScales = []
        if (product) {
          viewProduct = product
        }
        viewScales = cloneDeep(viewProduct.scales)
        viewScales = viewScales?.filter((scale: any) => {
          // 不可单卖 套餐不过滤
          const isDisable = !isCombo && scale.status === 'disable'
          // 时价
          const isOpenPrice = restaurantConfig.hideOpenPriceProduct && scale.isOpenPrice
          return !isDisable && !isOpenPrice
        })
        const modifierGroups = viewCartItem.modifierGroups?.map((modifierGroup: IDoModifierGroup) => {
          modifierGroup.modifiers = modifierGroup.modifiers.map((modifier: IDoModifierGroupItem) => {
            const _key = `${viewCartItem?.productNo}_${modifierGroup?.no}_${modifier?.no}`
            if (modifier.price) {
              if (discountMobx.itemDiscountMap?.[_key]) {
                modifier.discountPrice = discountMobx.itemDiscountMap?.[_key]?.off
                modifier.actualPrice = toDecimal(modifier.price - modifier.discountPrice) as number
              } else {
                modifier.discountPrice = 0
                modifier.actualPrice = modifier.price
              }
            }
            return modifier
          })
          return modifierGroup
        })
        let defaultModifierGroups: IModifierGroup
        defaultModifierGroups = modifierGroups[0]
        // 将试图餐品变成操作餐品
        // const modifierGroups = convertFilterModifierGroupsTomodifierGroups(viewCartItem.modifierGroups, viewCartItem.productNo)
        const scales = cloneDeep(viewScales).map((scale: IScale) => {
          // 处理金额因为openPrice是一个可变金额所有需要另一个参数price
          if (scale.isOpenPrice) {
            scale.price = undefined
          } else if (!hasDiscount) {
            // 对接营销价格
            if (scale.price) {
              if (discountMobx.itemDiscountMap && discountMobx.itemDiscountMap[viewProduct.no + '_' + scale.no]) {
                scale.discountPrice = discountMobx.itemDiscountMap[viewProduct.no + '_' + scale.no].off
                scale.actualPrice = toDecimal(scale.price - scale.discountPrice) as number
              } else {
                scale.discountPrice = 0
                scale.actualPrice = scale.price
              }
            }
          }
          return scale
        })
        // 处理金额因为openPrice是一个可变金额所有需要另一个参数price
        if (viewProduct.isScaleOpenPrice) {
          const _idx = scales.findIndex(scale => scale.no === viewCartItem?.scaleNo)
          if (_idx > -1 && scales?.[_idx]) {
            scales[_idx].price = viewCartItem.price
          }
        }
        const doProduct: IDoProduct = {
          type: viewCartItem.type,
          no: viewCartItem.productNo,
          name: viewCartItem.name,
          pic: viewProduct.pic,
          cnt: viewCartItem.cnt,
          scaleNo: viewCartItem.scaleNo, // 默认选中第一个可售的规格
          isTogo: viewCartItem.isTogo, // 来自购物车项的逆向
          isCanTogo: viewCartItem.isCanTogo,
          isSingleSale: viewProduct.isSingleSale,
          scales,
          addPrice,
          scaleGroupName: viewProduct.scaleGroup.name,
          modifierGroups,
          modifierGroupsNo: defaultModifierGroups ? defaultModifierGroups.no : null, // 默认选中第一个可售规格
          startTime: viewCartItem.startTime,
          pickTimeRange: viewCartItem.pickTimeRange,
          startTimeOffset: viewCartItem.startTimeOffset || 0,
          pk: viewCartItem.pk,
          intro: viewCartItem.intro,
          maxSalesCnt: viewProduct.maxSalesCnt,
          saleCnt: viewProduct.saleCnt,
          saleTotalCnt: viewProduct.saleTotalCnt,
          statSaleCnt: viewProduct.statSaleCnt,
          salesCnt: viewCartItem.salesCnt || viewProduct.salesCnt,
          remark: viewCartItem.remark,
          isOpenPrice: viewProduct.isOpenPrice,
          isScaleOpenPrice: viewProduct.isScaleOpenPrice,
          picBig: viewProduct.picBig,
          picWidth: viewProduct.picWidth,
          picHeight: viewProduct.picHeight,
          allergys: viewProduct.allergys,
          tags: viewProduct.tags,
          // TODO: 考虑存储的节点
          itemPlan: (discountMobx.discountAction.itemPlan && discountMobx.discountAction.itemPlan[viewCartItem.pk]) || (typeof (viewCartItem.openPriceX) !== 'undefined' && viewCartItem.openPriceX !== -1 && { type: 'changeFee', value: viewCartItem.openPriceX }) || null,
          isScaleModifierGroup: viewScales.some(scale => !!scale.modifierGroups),
          addUserId: viewCartItem.addUserId,
          addUserName: viewCartItem.addUserName,
          addUserAvatar: viewCartItem.addUserAvatar,
          taxCategoryId: viewProduct.taxCategoryId,
          isTaxFree: !!feeMobx.taxFreeAction[viewCartItem.pk],
          swapBuyProducts: viewCartItem.swapBuyProducts,
          timestamp: viewCartItem.timestamp,
          fullItemNFreeProducts: viewCartItem.fullItemNFreeProducts,
          seat: viewCartItem.seat,
          isOrderSwapBuy: isOrderSwapBuy || viewCartItem.isOrderSwapBuy
        }
        if (groupNo) {
          doProduct.groupNo = groupNo
        }
        if (typeof (viewCartItem.openPriceX) !== 'undefined' && viewCartItem.openPriceX !== -1) {
          doProduct.openPriceX = viewCartItem.openPriceX
        }
        this.doProduct = doProduct
      }
    } else {
      this.doProduct = getDefaultProduct()
    }
    this.pickExt()
  }

  /** 判断当前餐品是否在购物车内 */
  isInCart (viewProduct: IDoProduct) {
    const modifierGroups = viewProduct.modifierGroups.filter(item => item.cnt).map((item) => {
      return {
        ...item,
        modifiers: item.modifiers.filter(item => item.cnt)
      }
    })
    const fkey = createFkey({ productNo: viewProduct.no, scaleNo: viewProduct.scaleNo, modifierGroups, addUserId: '', isTogo: 0, startTime: '', isSeat: '' })
    const cartItem = find(cartMobx.cartItems, (item) => {
      const _fkey = createFkey({ productNo: item.productNo, scaleNo: item.scaleNo, modifierGroups: item.modifierGroups, addUserId: '', isTogo: 0, startTime: '', isSeat: '' })
      return _fkey === fkey
    })
    return !!cartItem
  }

  /** 额外信息 */
  pickExt (data?: {}) {
    if (data) {
      this.doProductExt = data
    } else {
      this.doProductExt = getDefaultProductExt()
    }
  }

  /** 选择规格、加料 */
  setModifyAndScalesStyle (newScale: any, newModify: any) {
    this.doProduct.scales = newScale
    this.doProduct.modifierGroups = newModify
  }

  /** 重置doProduct */
  reset () {
    const cnt = this.doProduct.cnt
    if (this.doProduct.pk) {
      this.pick({ cartItemPk: this.doProduct.pk })
    } else {
      this.pick({ productNo: this.doProduct.no })
    }
    this.doProduct.cnt = cnt
  }

  /** 将一个pk还原成doProduct */
  restore (pk: string, cnt: number = 1) {
    const doProduct = restorePkToDoProduct(pk, cnt)
    if (doProduct) {
      this.doProduct = doProduct
    }
  }

  /** 选择规格 */
  selectScale (scaleNo: string) {
    // 如果是一个来自套餐的餐品则不能修改规格
    if (this.doProduct.groupNo) {
      return
    }
    const scale = this.doProduct.scales.find((scale) => scale.no === scaleNo)
    if (scale) {
      if (scale.saleCnt !== 0) {
        this.doProduct.scaleNo = scale.no
        if (this.doProduct.isScaleModifierGroup) {
          // 上一次选择的口味加料，如果有相同规格级加料直接复制
          const preModifierGroups = cloneDeep(this.doProduct.modifierGroups)
          let modifierGroups = (scale.modifierGroups ? convertModifierGroupsToDoModifierGroups(this.doProduct?.no, scale.modifierGroups) : []).map((modifier) => {
            const hasModifier = find(preModifierGroups, (item) => item.id === modifier.id)
            if (hasModifier) {
              return hasModifier
            }
            return modifier
          })
          this.doProduct.modifierGroups = modifierGroups
        }
      }
    }
  }

  /** 选择加料组 */
  selectModifierGroup (modiferNo: string) {
    const modifer = this.doProduct.modifierGroups.find((modifer) => modifer.no === modiferNo)
    if (modifer) {
      this.doProduct.modifierGroupsNo = modifer.no
    }
  }

  /** 选择加料项 */
  selectModifier (modifierGroupNo: string, modifierGroupItemNo: string) {
    const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === modifierGroupNo)
    if (doComponent) {
      const doComponentItem = doComponent.modifiers.find(item => item.no === modifierGroupItemNo)
      if (doComponentItem && !doComponentItem.cnt && doComponent.cnt === doComponent.selectMax && !((doComponent.selectMin === 1 || doComponent.selectMin === 0) && doComponent.selectMax === 1)) {
        return
      }
      // 优化为单选模式
      if (doComponent.isReady && (doComponent.selectMin === 1 && doComponent.selectMax === 1)) {
        const selectedItem = doComponent.modifiers.find((item) => item.cnt === 1)
        if (selectedItem) {
          selectedItem.cnt = 0
          if (doComponentItem) {
            doComponentItem.cnt = 1
          }
        }
      } else if (doComponent.selectMin === 0 && doComponent.selectMax === 1) {
        const selectedItem = doComponent.modifiers.find((item) => item.cnt === 1)
        if (selectedItem) {
          selectedItem.cnt = 0
          if (doComponentItem && selectedItem.no !== doComponentItem.no) {
            doComponentItem.cnt = 1
          }
        } else if (doComponentItem) {
          doComponentItem.cnt = 1
        }
      } else {
        // 可叠加模式
        if (doComponentItem) {
          if (doComponentItem.cnt) {
            doComponentItem.cnt = 0
            doComponent.cnt--
          } else {
            doComponentItem.cnt = 1
            doComponent.cnt++
          }
        }
      }
      if (doComponent.cnt >= doComponent.selectMin && doComponent.cnt <= doComponent.selectMax) {
        doComponent.isReady = true
      } else {
        doComponent.isReady = false
      }
    }
  }

  /** 反选加料项 */
  unselectModifier (modifierGroupNo: string, modifierGroupItemNo: string) {
    const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === modifierGroupNo)
    if (doComponent) {
      const selectedItem = doComponent.modifiers.find(item => item.no === modifierGroupItemNo)
      if (selectedItem) {
        const selectedItemC = selectedItem.cnt
        selectedItem.cnt = 0
        doComponent.cnt -= selectedItemC
        doComponent.isReady = doComponent.cnt >= doComponent.selectMin && doComponent.cnt <= doComponent.selectMax
      }
    }
  }

  /** 增加口味项（针对加减模式） */
  addModifier (modifierGroupNo: string, modifierGroupItemNo: string, isSupportChoice = false): 'NONE' | 'MODIFIER' | 'MODIFIERGROUP_ITEM' | 'MODIFIERGROUP_CNT' | true {
    const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === modifierGroupNo)
    if (!doComponent) {
      return 'NONE'
    }
    const doComponentItem = doComponent.modifiers.find(item => item.no === modifierGroupItemNo)
    if (!doComponentItem) {
      return 'NONE'
    }
    // 支持单选混杂
    if (isSupportChoice && doComponentItem.cnt === 1 && doComponentItem.maxCnt === 1) {
      doComponentItem.cnt = 0
      doComponent.cnt--
      doComponent.itemCnt--
    } else {
      if (doComponentItem.cnt >= doComponentItem.maxCnt && doComponentItem.maxCnt !== -1) {
        return 'MODIFIER'
      }
      // 组中选中的项的份数不得大于限制份数
      if (!doComponentItem.cnt && doComponent.itemCnt === doComponent.selectMax) {
        return 'MODIFIERGROUP_ITEM'
      }
      // 选择项的总数不能大于限制数
      if (doComponent.maxCnt !== -1 && doComponent.cnt === doComponent.maxCnt) {
        return 'MODIFIERGROUP_CNT'
      }
      // 可叠加模式
      if (!doComponentItem.cnt) {
        doComponent.itemCnt++
      }
      doComponentItem.cnt++
      doComponent.cnt++
    }
    doComponent.isReady = doComponent.itemCnt >= doComponent.selectMin && doComponent.itemCnt <= doComponent.selectMax && (doComponent.cnt <= doComponent.maxCnt || doComponent.maxCnt === -1)
    return true
  }

  /** 减少口味项（针对加减模式） */
  reduceModifier (modifierGroupNo: string, modifierGroupItemNo: string) {
    const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === modifierGroupNo)
    if (!doComponent) {
      return false
    }
    const doComponentItem = doComponent.modifiers.find(item => item.no === modifierGroupItemNo)
    if (!doComponentItem) {
      return false
    }
    if (!doComponentItem.cnt) {
      return false
    }
    // 可叠加模式
    if (doComponentItem.cnt === 1) {
      doComponent.itemCnt--
    }
    doComponentItem.cnt--
    doComponent.cnt--
    if (doComponent.cnt < doComponent.selectMin) {
      doComponent.isReady = false
    }
  }

  /** 清除加料组 */
  clearModifierGroup (modifierGroupNo: string) {
    const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === modifierGroupNo)
    const modifierGroups = convertModifierGroupsToDoModifierGroups(this.doProduct?.no, this.doProduct.modifierGroups)
    if (doComponent) {
      // doComponent.cnt = 0
      // doComponent.modifiers.forEach((item) => (item.cnt = 0))
      // doComponent.isReady = restaurantConfig.app === 'pos' ? false : doComponent.selectMin === 0
      const mg = (modifierGroups.find(g => g.no === modifierGroupNo) as IDoModifierGroup)
      doComponent.cnt = mg?.cnt || 0
      doComponent.itemCnt = mg?.itemCnt || 0
      doComponent.modifiers = mg?.modifiers
      if (doComponent.cnt >= doComponent.selectMin && doComponent.cnt <= doComponent.selectMax) {
        doComponent.isReady = true
      } else {
        doComponent.isReady = false
      }
      this.doProduct.modifierGroups = [...modifierGroups]
    }
  }

  private _modifierGroupState: {
    no: string;
    cnt: number;
    modifierCnts: number[];
    isReady: boolean;
  } | null = null

  /** 记录 */
  recordModifierGroup (modifierGroupNo: string) {
    const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === modifierGroupNo)
    if (doComponent) {
      this._modifierGroupState = {
        no: doComponent.no,
        cnt: doComponent.cnt,
        modifierCnts: doComponent.modifiers.map((item) => item.cnt),
        isReady: doComponent.isReady
      }
    }
  }

  saveModifierGroup () {
    this._modifierGroupState = null
  }

  restoreModifierGroup () {
    if (this._modifierGroupState) {
      const doComponent = this.doProduct.modifierGroups.find((modifierGroup) => modifierGroup.no === this._modifierGroupState?.no)
      if (doComponent) {
        doComponent.cnt = this._modifierGroupState.cnt
        doComponent.modifiers.forEach((modifier, index) => {
          modifier.cnt = this._modifierGroupState?.modifierCnts[index] || 0
        })
        doComponent.isReady = this._modifierGroupState.isReady
      }
    }
  }

  /** 设置一个openPrice的餐品的价格 */
  setOpenPrice (price: number | string | undefined, scaleNo?: string) {
    if (typeof price === 'undefined') {
      this.doProduct.scales[0].price = undefined
      return
    }
    price = parseFloat(price.toString())
    if (price <= 99999 && price >= 0) {
      if (scaleNo) {
        let scale = this.doProduct.scales.find(scale => scale.no === scaleNo)
        if (scale) {
          scale.price = price
        } else {
          this.doProduct.scales[0].price = price
        }
      } else {
        this.doProduct.scales[0].price = price
      }
    }
  }

  /** 直接设置餐品数量 */
  setCnt (cnt: number) {
    // this.doProduct.cnt = cnt
    this.doProduct = {
      ...this.doProduct,
      cnt
    }
  }

  /** 设置餐品备注 */
  setRemark (remark: string) {
    this.doProduct.remark = remark
  }

  /** 设置延迟时间 */
  setStartTimeOffset (time: number) {
    this.doProduct.startTimeOffset = time
  }

  checkModifyInvalid (preCnt?: number) {
    let overSaleCnt = 0
    const modifier = flatten(zipWith(this.doProduct.modifierGroups, item => item.modifiers.filter(i => i.cnt > 0).map(i => ({ ...i, groupNo: item.no, groupCnt: item.cnt })))).filter(modify => productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`])
    if (modifier?.length > 0) {
      for (let j = 0; j < modifier?.length; j++) {
        const modify = modifier[j]
        const saleCnt = (this.doProduct.cnt + (preCnt || 0)) * modify.cnt - productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt
        if (saleCnt > 0) {
          overSaleCnt = saleCnt
          break
        }
      }
    }
    return overSaleCnt
  }

  /** 检查最大限售数量 当前加购数量是否超过限售数量 */
  checkMaxSalesCnt () {
    const maxSalesCnt = this.doProduct.maxSalesCnt || 0
    if (maxSalesCnt) {
      const pk = this.doProduct.pk
      const thisCartCnt = pk ? (cartMobx.pkToViewCartItemMap?.[pk]?.cnt || 0) : 0
      const cartCnt = cartMobx.noToCartItemsCntMap[this.doProduct.no] || 0
      const cnt = this.doProduct.cnt
      if (cnt + cartCnt - thisCartCnt > maxSalesCnt) {
        return maxSalesCnt
      }
    }
    return 0
  }

  /** 检查购物车最大限售数量 当前加购数量是否超过限售数量 cnt 增加数量 */
  checkCartItemMaxSalesCnt (productNo: string, addCnt: number = 1) {
    const product = productMobx.noToViewProductMap[productNo]
    const maxSalesCnt = product.maxSalesCnt || 0
    if (maxSalesCnt) {
      const cartCnt = cartMobx.noToCartItemsCntMap[product.no] || 0
      if (addCnt + cartCnt > maxSalesCnt) {
        return maxSalesCnt
      }
    }
    return 0
  }

  /** 检测当前的餐品选择是否可通过验证（有别于isReady，当前主要处理限售计算问题） */
  checkInvalid (): number {
    // const isPayModeOrderFirst = !isEmpty(orderMobx?.order?.ordersId) && orderMobx?.order?.payMode?.toString() === '0' && location.hash.includes('/menu')
    if (!productSaleMobx.isInLimit) {
      return 0
    }
    // 判断是特殊预约餐品也不校验库存
    if (!!this.doProduct.startTime || !!this.doProduct.pickTimeRange) {
      return 0
    }
    // 当前scaleNo为0，当时售卖中餐品级记录的是-1
    const theProductNo = this.doProduct.no
    const theScaleNo = this.doProduct.scaleNo
    const cartItemCnt = cartMobx.viewCartItems.find((item: any) => item.pk === this.doProduct.pk)?.cnt || 0
    return this.checkInvalidByProductNo(theProductNo, theScaleNo, cartItemCnt, this.doProduct.cnt)
  }
  /**
   *
   * @param theProductNo :餐品No
   * @param theScaleNo : 规格No
   * @param cartItemCnt : 购物车数量
   * @param cnt: 当前购买数量
   * @param isOrderSwapBuy 整单换购标识判断
   * @returns
   */
  checkInvalidByProductNo (theProductNo: string, theScaleNo: string | null, cartItemCnt: number, cnt: number, isOrderSwapBuy?: boolean) {
    const productSaleStaus = productSaleMobx.menuProductNoToCntMap[theProductNo]
    const productScales = productMobx.noToViewProductMap?.[theProductNo]?.scales?.filter(scale => scale.status !== 'disable')
    // 非整单换购的餐品限购状态
    if (productSaleStaus && productSaleStaus.cnt > 0 && !isOrderSwapBuy) {
      const currentCount = (cartMobx.cartResult.allProductNoToCntMap[theProductNo] || 0) + cnt - cartItemCnt
      if (currentCount > productSaleStaus.cnt) {
        return restaurantConfig.app === 'pos' ? currentCount - productSaleStaus.cnt : 9001
      }
    }
    // 非整单换购的多规格餐品限购
    if (productScales?.length > 0 && !isOrderSwapBuy) { // 多规格餐品，判断规格级
      const scaleSaleStaus = productSaleMobx.scaleNoToCntMap[theProductNo + '_' + theScaleNo]
      if (scaleSaleStaus && scaleSaleStaus.cnt > 0) {
        const currentSaleCount = (cartMobx.cartResult.allScaleNoToCntMap[theProductNo + '_' + theScaleNo] || 0) + cnt - cartItemCnt
        if (currentSaleCount > scaleSaleStaus.cnt) {
          return restaurantConfig.app === 'pos' ? currentSaleCount - scaleSaleStaus.cnt : 9001
        }
      }
    }
    if (isOrderSwapBuy) {
      if (discountMobx.orderSwapBuyActivity && discountMobx.orderSwapBuyActivity.buyAgainFee > 0) {
        // 不满足
        return discountMobx.orderSwapBuyActivity.buyAgainFee
      }
      const currentProductKey = theProductNo + '_' + theScaleNo
      // 整单换购活动餐品查询
      const filterProduct: any = filter(discountMobx.allOrderSwapBuyActityProducts, (product) => {
        const key = product.productNo + '_' + product.scaleNo
        return key === currentProductKey
      }) || []
      const currentCnt = cartMobx.cartResult.allScaleNoToCntMap[currentProductKey] || 0
      if (filterProduct && (filterProduct[0]?.cnt < currentCnt)) {
        return currentCnt - filterProduct[0]?.cnt
      }
    }
    return 0
  }

  /** 设置打包/堂食 */
  switchTogo () {
    if (cartMobx.info.eatType !== 'dinein') {
      return
    }
    this.doProduct.isTogo = this.doProduct.isTogo ? 0 : 1
  }

  /** 设置手工折扣，因为当前是暂存状态估存放在doProduct，实际使用后会存储到discountMobx中 */
  setDiscountPlan (plan?: IDiscountPlan | null) {
    this.doProduct.itemPlan = plan || null
  }

  setTaxFee () {
    this.doProduct.isTaxFree = !this.doProduct.isTaxFree
  }

  /** 设置预约时间 */
  setStartTime (startTime?: string, pickTimeRange?: any) {
    this.doProduct.startTime = startTime
    this.doProduct.pickTimeRange = pickTimeRange
  }
}

export { DoProduct, restorePkToDoProduct }

export default new DoProduct()
